module.exports = __webpack_public_path__ + "static/media/reel-right-arrow.c81d2615.svg";